.fs{border:1px solid #ddd;}